import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MatDialog } from '@angular/material/dialog';
import { SmartContractService } from "../smart-contract-management.service";
import { DeleteDialogComponent } from "src/app/shared/dialogs/delete-dialog/delete-dialog.component";
import { FabricChaincode } from "@aptsi-types";
import { Subject } from "rxjs";
import { KeycloakStateService } from "src/app/core/service/utility.service";


@Component({
  selector: 'app-smart-contract-search',
  templateUrl: './smart-contract-management-search.component.html',
  styleUrls: ['./smart-contract-management-search.component.scss']
})
export class SmartContractManagementSearchComponent implements OnInit {

  contracts: FabricChaincode[] = [];
  filteredData: FabricChaincode[] = [];
  searchedData: FabricChaincode[] = [];

  // ─── Pagination ───────────────────────────────────────────────
  currentPage = 1;
  itemsPerPage = 7;
  totalPages = 1;

  // ─── Search ──────────────────────────────────────────────────
  searchText: string = "";
  filterByHeader: string = "all";
  searchTextChanged = new Subject<string>();
  //filterByStatus: string = '';

  organizationId: string | null = '';

  issearch: boolean = false;
  loading: boolean = false;

  headers = [
    { name: 'ID', property: 'chaincodeId', showInDropdown: true },
    { name: 'Smart Contract Name', property: 'chaincodeName', showInDropdown: true },
    { name: 'Channel', property: 'channelName', showInDropdown: true },
    { name: 'Status', property: 'status', showInDropdown: true }
  ];

  buttonConfig = {
    update: true,
    delete: true,
    revoke: false
  };

  constructor(
    private service: SmartContractService,
    private router: Router,
    private dialog: MatDialog,
    private keycloakStateService: KeycloakStateService
  ) { }

  ngOnInit(): void {
     this.organizationId = this.keycloakStateService.getOrganizationId();
    this.fetch();
  }

  fetch(): void {
    this.service.getContracts(this.organizationId).subscribe((res: any[]) => {
      this.contracts = res;
      this.filteredData = this.contracts;
    });
  }

  back(): void {
    this.router.navigate(["secure-blockchain/auth-tools"]);
  }

  changePage(page: number): void {
    this.currentPage = page;
  }

  onSearchTextChange(): void {

    if (!this.searchText) {
      this.issearch = false;
      this.fetch();
      return;
    }

    this.issearch = true;

    this.service
      .searchContracts(this.currentPage-1, this.searchText, this.filterByHeader, this.organizationId )
      .subscribe((res: any[]) => {
        this.searchedData = res;
      });
  }

  handleAction(event: any): void {
    const row = event.rowData;

    if (event.action === "update") {
      this.router.navigate(['/secure-blockchain/auth-tools/smart-contract/update', row.chaincodeId]);
    }

    else if (event.action === "delete") {

      const dialogRef = this.dialog.open(DeleteDialogComponent, {
        width: '400px',
        data: {
          title: 'Delete Smart Contract',
          message: `Are you sure you want to delete "${row.chaincodeName}"?`
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {

        if (!confirmed) return;

        this.loading = true;

        const payload = {
          chaincodeName: row.chaincodeName,
          channelName: row.channelName,
          organizationId: row.organizationId,
          organization: row.organization,
          version: row.version,
          sequence: row.sequence
        };

        this.service.deleteContract(payload).subscribe((res: any) => {

          const jobId = res?.jobId;

          if (!jobId) {
            this.loading = false;
            alert("Failed to start delete job");
            return;
          }

          this.pollJob(jobId, () => {
            this.fetch();
          });

        });
      });
    }
  }

  create(): void {
    this.router.navigate(['/secure-blockchain/auth-tools/smart-contract/create']);
  }

  pollJob(jobId: string, onSuccess: () => void) {

    const interval = setInterval(() => {

      this.service.getStatus(jobId).subscribe((res: any) => {

        console.log("Job status:", res.status);

        if (res.status === 'SUCCESS') {
          clearInterval(interval);
          this.loading = false;
          onSuccess();
        }

        if (res.status === 'FAILED') {
          clearInterval(interval);
          this.loading = false;
          alert("Delete failed");
        }

      });

    }, 3000);
  }
}